<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container bottom-footer">
        <!-- Outer Row -->
        <div class="row justify-content-center">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <LogoColor formatting="logo-center" width="350px"></LogoColor>
                <div class="card o-hidden border-0 shadow-lg">
                    <div class="card-body p-0">
                        <!-- Nested Row within Card Body -->
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <div class="p-5">
                                    <div class="text-center">
                                        <div class="alert alert-info">
                                            <p class="text-justify">Estamos felizes em ter você com a gente! 💙. Antes
                                                de entrar no sistema, por gentileza, redefina a sua senha por
                                                segurança.</p>
                                        </div>
                                        <h6 class="text-gray-900 text-justify"></h6>
                                        <hr>
                                    </div>
                                     <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
                                    <form class="user" @submit="checkAuthentication">
                                        <div class="form-group">
                                            <label for="">No senha</label>
                                            <input type="password" class="form-control form-control-user"
                                                id="newPassword" placeholder="********"
                                                v-model="authentication.password">
                                        </div>
                                        <div class="form-group">
                                            <label for="">Confirmar nova senha</label>
                                            <input type="password" class="form-control form-control-user"
                                                id="newPasswordConfirm" placeholder="********"
                                                v-model="authentication.confirm_password">
                                        </div>

                                        <button type="submit" :disabled='!isDisabled'
                                            class="btn btn-primary btn-user btn-block">
                                            <i class="fas fa-check"></i> Definir nova senha
                                        </button>
                                    </form>
                                    <hr>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import LogoColor from '../img/logo-color.vue';
import { handleRequestErrors } from '@/handleErrors';
import api from '@/api';


export default {
    directives: { mask },
    components: { LogoColor, Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            url_api: '',
            enable_error_list: false,
            errors: [],
            authentication: {
                password: '',
                confirm_password: ''
            }
        }
    },
    computed: {
        isDisabled: function () {
            return this.authentication.password != '' && this.authentication.confirm_password != '';
        }
    },
    methods: {
        onCancel() { },
        async checkAuthentication(event) {
            event.preventDefault();
            this.isLoading = true;
            api.post('/user/resetPasswordTemporary', this.authentication)
                .then(() => {
                   this.$notify({
                    title: "Sucesso",
                    text: "Senha atualizada com sucesso!",
                    type: 'success'
                });
            
                localStorage.setItem('change_password',false);
                this.$router.push('/');
                this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })
        }
    },
    mounted() {

        this.isLoading = false;
        this.url_api = process.env.VUE_APP_URL_API

    }
}
</script>

<style>
* {
    scrollbar-width: none;
}

.bottom-footer {
    margin-top: 5%;
    margin-bottom: 400px;
}
</style>